import React from 'react';
import { Alert, AlertTitle, Box } from '@chakra-ui/react';
export var ApiStatusView = function (_a) {
    var message = _a.message, status = _a.status, icon = _a.icon;
    return (React.createElement(Box, { my: 8 },
        React.createElement(Alert, { status: status },
            icon,
            React.createElement(AlertTitle, { ml: 2 }, message))));
};
